$(function () {
    if($('#myDropzone').length){
        let myDropzone = new Dropzone("#myDropzone", {
            acceptedFiles: 'text/csv',                   //errr, how to allow csv only?
            url: '/product-import/upload/'
        });
        myDropzone.on('success', function(file){      
            var response = file.xhr.responseText;

            if (response == "columnerror") {
                $("#output").prepend('<div>Missing some mandatory columns. Please check the CSV file!</div>');
                myDropzone.removeFile(file);
            } else {
                $("#output").prepend('<div>Start importing, please do not close the browser ...</div>');
                runImport();
            }
        });

        myDropzone.on('error', function(file){
            $("#output").prepend('<div>Start importing, please do not close the browser ...</div>');
            runImport();
        });

        if(needMigration != 0){
            $("#output").prepend('<div><a href="#" class="import-resumt-btn">Click here</a> to resume or <a href="/product-import/clear/">Click here</a> to flush the queue</div>');
            $("#output").prepend('<div>' + needMigration + ' items left in the queue</div>');

            $('.import-resumt-btn').click(function (e) {
                e.preventDefault();
                $("#output").html('');
                $("#output").prepend('<div>Start importing, please do not close the browser ...</div>');
                runImport();
            });
        }else{
            $("#output").prepend('<div>No item in the queue</div>');
        }
    }

});

function runImport() {
    $.get('/product-import/execute/').then(function (respond) {
        if(respond != 0){
            $("#output").prepend('<div>' + respond + ' items left in the queue, importing... </div>');
            runImport();
        }else{
            $("#output").prepend('<div>Finished</div>');
        }
    });
}
